import { render, staticRenderFns } from "./BucketTableField.vue?vue&type=template&id=70b28349"
import script from "./BucketTableField.vue?vue&type=script&lang=js"
export * from "./BucketTableField.vue?vue&type=script&lang=js"
import style0 from "./BucketTableField.vue?vue&type=style&index=0&id=70b28349&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports